// HEAD
import type { Accessor, Component } from 'solid-js'
import type { DivProps } from '../../ui/utils-ui'
import type { IconifyButtonProps } from '../mini-components'
import { Logger } from 'besonders-logger'
import { Match, Show, splitProps, Switch } from 'solid-js'
//
// 3e1fe6a9079c5e1e5ea35d30d46089f5ccd0e1d0
import { useAgent } from '../../data/agent/AgentState'
import { IconifyButton } from '../mini-components'
import { AgentEditor } from './AgentEditor'
import { DeviceDialog } from './DeviceDialog'
import { MnemDialog } from './MnemDialog'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO) // eslint-disable-line unused-imports/no-unused-vars

export const AgentSettings: Component<DivProps & {
	initialSetup?: boolean
	onSave?: () => void
	params?: Accessor<string[]>
}> = (allProps) => {
	const [props, restProps] = splitProps(allProps, ['initialSetup', 'onSave'])
	DEBUG.force('Creating <AgentSettings>') // HACK used to render twice and sideEffects should only happen once if possible
	const agent = useAgent() // ? are there reactivity reasons not to destructure here?
	// let mnemDialogRef
	const setupButtonData: IconifyButtonProps = {
		icon: 'gear',
		onClick: () => WARN('TODO'),
		text: 'Setup your user agent',
		variant: 'success',
		title: 'Click here to change your username and setup your identity',
	}
	return (
		// <div flex='~ col' gap-4>
		<wa-card class='card-header' style={{ '--border-colly': '#ffffff77', '--padding': 'var(--wa-spacing-medium)' }} {...restProps}>
			<div slot='header'>
				<Show when={props.initialSetup}>
					You are using the default agent
				</Show>
				<Show when={!props.initialSetup}>
					Your user info
					<Show when={!props.initialSetup}>{` (${agent.ag})`}</Show>
				</Show>
			</div>
			<Switch>

				<Match when={props.initialSetup}>
					<IconifyButton variant='success' {...setupButtonData} />
				</Match>
				<Match when={!props.initialSetup}>
					<div flex='~ col' gap-4>
						<div>
							<div mb-1 font-bold>Set up your agent string:</div>
							<AgentEditor
								mb-2
								initialSetup={props.initialSetup}
								onSave={props.onSave}
							/>
							<p opacity-60>
								This handle (which includes the tail end of your agent
								{' '}
								<a href='https://en.wikipedia.org/wiki/Decentralized_identifier' target='_blank'>DID</a>
								)
								{' '}
								<br />
								is what other devices will see as the author of the data you create
								{' '}
								<br />
								{' '}
								<em>... if you choose to share it</em>
								.
							</p>

						</div>
					</div>

					<div slot='footer' flex='~ wrap justify-start' gap-2>
						{/* <MnemDialog mnemDialogRef={mnemDialogRef} /> */}
						<MnemDialog />
						<DeviceDialog />
					</div>
					{/* TODO: <SlCopyButton  />  */}
				</Match>
			</Switch>
		</wa-card>
		// </div>
	)
}
